module.exports = __webpack_public_path__ + "static/img/18.2e6fd3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/18.jpg
// module id = genc
// module chunks = 1